class BrixRichText {
  static init(...parameters) {
    return new BrixRichText(...parameters);
  }

  constructor(block) {
    if (block) {
      this.block = block;
      this.toggleReadMore();
    }
  }

  toggleReadMore() {
    const readMoreButton = this.block.querySelector('.rich-text-read-more');
    const content = this.block.querySelector('.content');

    if (content) {
      const { readLessLabel } = content.dataset;
      if (readMoreButton) {
        readMoreButton.addEventListener('click', () => {
          readMoreButton.classList.add('-show-more');
        });

        const readLessButton = document.createElement('button');
        const readLessText = document.createElement('span');
        readLessButton.classList.add('rich-text-read-less');
        readLessText.classList.add('rich-text-read-less-label');
        readLessText.innerText = readLessLabel;
        readLessButton.appendChild(readLessText);
        content.appendChild(readLessButton);

        readLessButton.addEventListener('click', () => {
          readMoreButton.classList.remove('-show-more');
        });
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-rich-text', BrixRichText.init);
}
